module.exports = __webpack_public_path__ + "static/img/1.1fa7a10.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/2/zh/1.png
// module id = 8ANC
// module chunks = 0